<template>
	<div class="drag-input-unit">
		<drag-input :max="max" :min="min" :icon="icon" :value="value.value" @input="onChange"/>
		<select  @change="onChangeUnit" :value="value.unit">
		  <option  v-for="option in unit_options" :value="option">  {{ option }} </option>
		</select>
	</div>
</template>
<script>
import DragInput from "./drag-input.vue";
	export default {
		components:{DragInput},
		name:"drag-input-unit",
		methods:{
			onChange(value){
				this.$emit('input',{unit:this.value.unit, value});
			},
			onChangeUnit(e){
				this.$emit('input',{unit:e.target.value, value:this.value.value});
			}
		},
		props:{
			value:{
				type:Object,
				default:function () { return {
					value:0,
					unit:'px'
				} }
			},
			icon:String,
			unit:{
				type:String,
				default:"px"
			},
			label:String,
			min: {
				type:Number,
				default: -999999999
			},
			max: {
				type:Number,
				default: 999999999
			}
		},
		data(){
			return {
				unit_options:['px','%','em']
			}
		}
	}
</script>
<style scoped>
	*{
		user-select: none;
		-webkit-user-select: none;
	}
	.drag-input-unit{
		display: inline-block;
		/*border:1px solid lightgrey;*/
		border-radius: 2px;
		cursor: ew-resize;
		font-size:12px;
		margin:0px;
		vertical-align: top;
	}

	select{
		    display: inline-block;
    width: 26px;
    height: 27px;
    border-radius: 0;
    -webkit-appearance: none;
    background: white;
    border-color: lightgrey;
    text-align: center;
    text-align-last: center;
    cursor: pointer;
    margin-left: -4px;
	}
	select:hover{
		background: whitesmoke;
	}
	option{
		text-align: center;

	}
</style>